import { useEffect, useState } from "react";
import { sectionAnchors } from "@/mocks/site";

export default function AnchorNav() {
  const [active, setActive] = useState(sectionAnchors[0].id);

  useEffect(() => {
    const onScroll = () => {
      let current = sectionAnchors[0].id;
      sectionAnchors.forEach((item) => {
        const el = document.getElementById(item.id);
        if (el && el.getBoundingClientRect().top <= 200) {
          current = item.id;
        }
      });
      setActive(current);
    };
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleClick = (id: string) => {
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <div className="sticky top-[70px] z-30 border-b border-background-200/70 bg-background-50/95 backdrop-blur md:top-[110px]">
      <nav className="mx-auto w-full max-w-[1280px] px-4 md:px-8">
        <ul className="no-scrollbar flex items-center gap-1 overflow-x-auto py-2.5">
          {sectionAnchors.map((item) => (
            <li key={item.id} className="shrink-0">
              <button
                type="button"
                onClick={() => handleClick(item.id)}
                className={`whitespace-nowrap rounded-full px-4 py-1.5 text-sm font-medium transition-colors duration-200 ${
                  active === item.id
                    ? "bg-foreground-950 text-background-50"
                    : "text-foreground-600 hover:bg-background-200/70"
                }`}
              >
                {item.label}
              </button>
            </li>
          ))}
        </ul>
      </nav>
    </div>
  );
}